var _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurpresa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 102,
    viewBox: "0 0 102 102",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3826_30403)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.11 73.1095C88.4254 59.7942 88.4254 38.2058 75.11 24.8905C61.7947 11.5752 40.2063 11.5752 26.891 24.8905C13.5757 38.2058 13.5757 59.7942 26.891 73.1095C40.2063 86.4248 61.7947 86.4248 75.11 73.1095Z",
    fill: "#FFD05D"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.8359 19.9C72.9895 26.4021 74.8153 34.1206 74.015 41.7945C73.2147 49.4684 69.8357 56.6441 64.4299 62.1492C59.0241 67.6544 51.9112 71.1636 44.2531 72.1035C36.595 73.0434 28.8446 71.3585 22.2679 67.324C25.0294 71.642 28.7289 75.2819 33.0911 77.9728C37.4534 80.6638 42.3662 82.3367 47.4642 82.8671C52.5622 83.3974 57.7142 82.7715 62.537 81.0361C67.3597 79.3006 71.7291 76.5001 75.3203 72.843C78.9114 69.1859 81.6318 64.7662 83.2791 59.9126C84.9265 55.0591 85.4584 49.8965 84.8353 44.8091C84.2122 39.7216 82.4501 34.84 79.6801 30.5275C76.9101 26.2149 73.2035 22.5824 68.8359 19.9Z",
    fill: "#FDC453"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5399 52.6C21.54 45.9888 23.6098 39.5436 27.4592 34.1686C31.3085 28.7936 36.744 24.7587 43.0031 22.63C49.2622 20.5013 56.0307 20.3856 62.3588 22.2992C68.687 24.2128 74.2572 28.0597 78.2879 33.3C76.1256 29.5448 73.2153 26.2735 69.7373 23.6888C66.2593 21.104 62.2876 19.2609 58.0684 18.2735C53.8491 17.2861 49.472 17.1754 45.2082 17.9484C40.9444 18.7213 36.8847 20.3615 33.2806 22.7672C29.6764 25.1729 26.6046 28.2929 24.2552 31.9341C21.9059 35.5752 20.3291 39.6599 19.6226 43.9352C18.9161 48.2105 19.0948 52.5853 20.1477 56.7887C21.2007 60.9922 23.1054 64.9346 25.7439 68.372C22.9829 63.5746 21.533 58.1351 21.5399 52.6Z",
    fill: "#FFD77F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40.952 40.7281C40.952 43.0681 39.828 44.9641 38.44 44.9641C37.052 44.9641 35.928 43.0681 35.928 40.7281C35.928 38.3881 37.052 36.4921 38.44 36.4921C39.828 36.4921 40.952 38.3881 40.952 40.7281Z",
    fill: "#303030"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.072 40.7281C66.072 43.0681 64.948 44.9641 63.56 44.9641C62.172 44.9641 61.048 43.0681 61.048 40.7281C61.048 38.3881 62.172 36.4921 63.56 36.4921C64.948 36.4921 66.072 38.3881 66.072 40.7281Z",
    fill: "#303030"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51 69.0001C54.3999 69.0001 57.156 64.3277 57.156 58.5641C57.156 52.8004 54.3999 48.1281 51 48.1281C47.6001 48.1281 44.844 52.8004 44.844 58.5641C44.844 64.3277 47.6001 69.0001 51 69.0001Z",
    fill: "#695342"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M56.2 64.16C51.708 61.692 48.052 63.092 45.936 64.492C47.044 67.216 48.9 69 51 69C53.184 69 55.104 67.068 56.2 64.16Z",
    fill: "#F06669"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3826_30403",
    x: 0.904541,
    y: 0.904053,
    width: 100.192,
    height: 100.192,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3826_30403"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3826_30403",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurpresa);
export default __webpack_public_path__ + "static/media/surpresa.87884aaff616026e7a5d4ac139129dd3.svg";
export { ForwardRef as ReactComponent };